import { normalizeUnitOfMeasure, type UnitOfMeasure } from '@shared/quantity';

/** Normaliza UoM desde SQLite / snapshot remoto. */
export function normalizeStockUnitOfMeasure(raw: unknown): UnitOfMeasure {
  return normalizeUnitOfMeasure(raw);
}
